import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";

const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }

const UafeService = {
    async GetList(qs) { 
        return await methods.Get("Uafe/List" + useParamsJson(qs)); 
    },
    async GetDetalleSucursales(qs) { 
        return await methods.Get("Uafe/DetalleSucursales" + useParamsJson(qs)); 
    },
    async GetRiesgoCatalogo() {
        return await methods.Get("Uafe/RiesgoCatalogo");
    },
    async UpdateRiesgo(data) {
        return await methods.Post("Uafe/UpdateRiesgo", data);
    }
};

export default UafeService;
